<template>
  <Menu as="div" class="relative inline-block text-left !overflow-visible">
    <div>
      <MenuButton
        :disabled="props.disabled"
        class="flex items-center text-sm font-medium rounded-xl px-2.5 py-1 disabled:cursor-not-allowed"
        :class="{
          'bg-green-50 text-green-500': isPublic,
          'bg-gray-100 text-gray-500': !isPublic,
        }"
        @click.stop
      >
        {{
          isPublic
            ? t("components.visibility.public")
            : t("components.visibility.private")
        }}
        <ChevronDownIcon class="-mr-1 h-5 w-5 ml-0.5" aria-hidden="true" />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="absolute right-0 z-50 mt-2 origin-top-right rounded-xs bg-white shadow-lg ring-opacity-5 focus:outline-none"
      >
        <div class="relative py-1">
          <MenuItem @click.stop="toggleVisibility()">
            <span
              class="whitespace-nowrap block px-4 py-1 text-[.8rem] hover:bg-gray-50"
              >{{
                isPublic
                  ? t("components.visibility.make_private")
                  : t("components.visibility.make_public")
              }}</span
            >
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/20/solid";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const emit = defineEmits(["change"]);
const props = defineProps({
  active: String,
  disabled: {
    type: Boolean,
    default: false,
  },
});

const _active = ref(props.active);

const isPublic = computed(() => _active.value === "public");

const toggleVisibility = () => {
  _active.value = _active.value === "public" ? "private" : "public";
  emit("change", _active.value);
};
</script>
